function componentsRepositionFooter() {
var footerLogo = 'https://cdn.myshoptet.com/usr/www.wilsondo.sk/user/documents/Scripty/images/wilsondo-logo-footer.svg';
  $(".payments-list")
    .closest(".banner")
    .parent()
    .addClass("custom-footer__banner--payments");

  $("#footer .copyright").prepend($("#footer .site-name"));
  $("#footer .site-name img").attr("src", footerLogo);

  // Wrap logo and text into .footer-meta
  var $footer = $("#footer");
  var $copyright = $footer.find(".copyright");

  var $cookieLink = $copyright.find(".js-cookies-settings").detach();
  var $siteName = $copyright.find(".site-name").detach();
  var fullText = $copyright.text().trim().replace($cookieLink.text().trim(), '');

  var $footerMeta = $('<div class="footer-meta"></div>');
  $footerMeta.append($siteName).append(' ' + fullText);

  $copyright.empty().append($footerMeta).append($cookieLink);

  // Move signature and payments into one block
  var $footerBottom = $(".footer-bottom");
  var $signature = $footerBottom.find("#signature").detach();
  var $paymentsList = $(".payments-list").closest(".banner-wrapper").detach();

  var $signatureWrapper = $('<div class="footer-signature"></div>');
  $signatureWrapper.append($signature).append($paymentsList);

  $footerBottom.prepend($signatureWrapper);



  // add business hours
  switch(shopName) {
    case 'wsk':
      var businessHoursUrl = '/kontakt/';
      break;
    case 'whu':
      var businessHoursUrl = '/elerhetoseg/';
      break;
    case 'wcz':
      var businessHoursUrl = '/kontakty/';
      break;
    case 'wro':
      var businessHoursUrl = '/contacte/';
      break;
    case 'wbg':
      var businessHoursUrl = '/kontakt/';
      break;
    case 'whr':
      var businessHoursUrl = '/kontakti/';
      break;
    case 'wsi':
      var businessHoursUrl = '/kontakti/';
      break;
    case 'wua':
      var businessHoursUrl = '/kontakt/';
      break;
    //testovaci e-shop
    case 'test':
      var businessHoursUrl = '/kontakty/';
      break;
    case 'dpc':
      var businessHoursUrl = '/kontakt/';
      break;
    case 'mee':
      var businessHoursUrl = '/rolunk/';
      break;
    case 'jam':
      var businessHoursUrl = '/o-nas/';
      break;
    case 'eag':
      var businessHoursUrl = '/rolunk/';
      break;
    case 'pos':
      var businessHoursUrl = '/o-nas/';
      break;
    default:
      return;
  }
  switch(lang) {
    case 'sk':
      var businessHoursTerm = 'Prevádzková doba zákazníckeho servisu:';
      var businessHoursTimeTerm = 'pondelok - piatok: 8:00 - 16:00';
      var businessHoursClass = 'business-hours-box';
      break;
    case 'hu':
      var businessHoursTerm = 'Ügyfélszolgálati idő:';
      var businessHoursTimeTerm = 'hétfőtől - péntekig: 8:00 - 16:00';
      var businessHoursClass = 'business-hours-box-hu';
      break;
    case 'cs':
      var businessHoursTerm = 'Provozní doba zákaznického servisu:';
      var businessHoursTimeTerm = 'po–pá 8–16 h.';
      var businessHoursClass = 'business-hours-box';
      break;
    case 'ro':
      var businessHoursTerm = 'Programul de lucru al serviciului clienți:';
      var businessHoursTimeTerm = 'luni - vineri: 8:00 - 16:00';
      var businessHoursClass = 'business-hours-box';
      break;
    case 'bg':
      var businessHoursTerm = 'Prevádzková doba zákazníckeho servisu:';
      var businessHoursTimeTerm = 'pondelok - piatok: 8:00 - 16:00';
      var businessHoursClass = 'business-hours-box';
      break;
    case 'hr':
      var businessHoursTerm = 'Radno vrijeme službe za korisnike:';
      var businessHoursTimeTerm = 'ponedjeljak - petak: 8:00 - 16:00';
      var businessHoursClass = 'business-hours-box';
      break;
    case 'sl':
      var businessHoursTerm = 'Delovni čas Službe za pomoč strankam:';
      var businessHoursTimeTerm = 'od ponedeljka do petka: 8:00 - 16:00';
      var businessHoursClass = 'business-hours-box';
      break;
    case 'uk':
      var businessHoursTerm = 'Prevádzková doba zákazníckeho servisu:';
      var businessHoursTimeTerm = 'pondelok - piatok: 8:00 - 16:00';
      var businessHoursClass = 'business-hours-box';
      break;
    default:
      return;
  }
  var businessHoursText = $('<div class="' + businessHoursClass + '"><a href="' + businessHoursUrl + '"><strong>' + businessHoursTerm + '</strong> </br>' + businessHoursTimeTerm + '</a></div>');
  $('#footer .contact-box.no-image').append(businessHoursText);
}
